import B1 from "../../Assets/Banner/b1.jpg";
import B2 from "../../Assets/Banner/b2.jpg";

export const bannerData = {
  home: [
    {
      heading: "",
      subheading: "",
      path: "/women/clothing/lengha_choli",
      image: B1,
    },
    {
      heading: "",
      subheading: "",
      path: "/women/clothing/lengha_choli",
      image: B2,
    },
    {
      heading: "",
      subheading: "",
      path: "/women/clothing/lengha_choli",
      image:
        "https://www.ethnicplus.in/media/mageplaza/bannerslider/banner/image/1/2/12_4.jpg",
    },
    {
      heading: "",
      subheading: "",
      path: "/women/clothing/lengha_choli",
      image:
        "https://www.ethnicplus.in/media/mageplaza/bannerslider/banner/image/9/_/9_8.jpg",
    },
  ],
};
